<template>
<div class="chapter">
<div class="inner_page">
<h1 class="part11">Only the Cat Knows</h1>
<p class="author">Marian Babson</p>
<div class="img_container4">
<img alt="Image" src="images/logo.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?ebded7aa